import React, { DependencyList, ReactNode, useEffect, useRef, useState } from 'react';

export const useUnmountOnChange = (values: DependencyList) => {
  const prevValuesRef = useRef(values);
  const [render, setRender] = useState(true);

  useEffect(() => {
    if (values.length !== prevValuesRef.current.length) {
      throw new Error('useUnmountOnChange: dependencies length changed');
    }
    if (values.some((value, index) => value !== prevValuesRef.current[index])) {
      setRender(false);
      prevValuesRef.current = values;
      return;
    }
    setRender(true);
  }, [...values, render]); // eslint-disable-line react-hooks/exhaustive-deps

  return render;
};

// Unmounts children after at least one of the dependencies changed and then triggers another update remounting them
export const UnmountOnChange = ({ children, dependencies }: { children: ReactNode, dependencies: DependencyList }) => {
  const render = useUnmountOnChange(dependencies);
  return (
    <>
      {render ? children : null}
    </>
  );
};
